export const environment = {
  production: true,
  configFile: 'assets/config/config.json',
  version: '2025-04-14.02',
};
